import { create } from "zustand";
import { FORFAIT_PAR_EQUIPE, LIST_FORFAIT } from "../../Utils/constant";
import { find, getAll } from "../../services/service";
export const useStoreForfait = create((set) => ({
  loading: false,
  data: [],
  ListForfait: [],
  count: 1,
  forfait: async (param) => {
    set({
      loading: true,
      data: [],
      count: 1,
    });

    try {
      const forfaitList = await getAll(LIST_FORFAIT, param, "");
      setTimeout(() => {
        set({
          loading: false,
          data: forfaitList.data,
          count: forfaitList.data.totalPages,
        });
      }, 800);
    } catch (error) {
      set({
        loading: true,
        data: [],
        count: 1,
      });
    }
  },
  forfaitByEquipe: async (id) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const forfaitList = await find(`${FORFAIT_PAR_EQUIPE}/${id}`);
      setTimeout(() => {
        set({
          loading: false,
          ListForfait: forfaitList.data,
        });
      }, 800);
    } catch (error) {
      set({
        loading: true,
        ListForfait: [],
      });
    }
  },
}));
